import { useContext } from 'react';
import { StoresContext } from './StoresContext';

export const useStores = () => useContext(StoresContext);
